import React from 'react';
export function StudentTableSkeleton({
  rows = 6
}: {
  rows?: number;
}) {
  return <div className="p-4" aria-busy="true" aria-live="polite" data-id="element-411" data-mp="el63b3nqy12v">
      <span className="sr-only" data-id="element-412" data-mp="emqtkh312xux">Loading student records from Supabase…</span>
      <div className="hidden md:block" data-id="element-413" data-mp="my6qwumh1s8">
        <div className="mb-3 flex items-center gap-4 px-2" data-id="element-414" data-mp="nzht1bn1o9y">
          {[26, 10, 12, 18, 18, 14].map((width, index) => <div key={index} className="shimmer h-3 rounded-full" style={{
          width: `${width}%`
        }} data-id="element-415" data-mp="t9sgaypwigqx" data-mpi={index} />)}
        </div>
        {Array.from({
        length: rows
      }).map((_, rowIndex) => <div key={rowIndex} className="flex items-center gap-4 border-t border-[var(--glass-hairline)] px-2 py-4" style={{
        opacity: 1 - rowIndex * 0.08
      }} data-id="element-416" data-mp="jkse76g3r58i" data-mpi={rowIndex}>
            <div className="shimmer h-9 w-9 shrink-0 rounded-xl" data-id="element-417" data-mp="1c9g279s8k8pr" />
            <div className="flex-1 space-y-2" data-id="element-418" data-mp="1c73eefzsr44s">
              <div className="shimmer h-3 w-1/3 rounded-full" data-id="element-419" data-mp="1h068qqceehm1" />
              <div className="shimmer h-2.5 w-1/4 rounded-full" data-id="element-420" data-mp="fny5yz4jt5xf" />
            </div>
            <div className="shimmer h-3 w-16 rounded-full" data-id="element-421" data-mp="flu5ys9rsr2f" />
            <div className="shimmer h-3 w-24 rounded-full" data-id="element-422" data-mp="apwmwe74h6ly" />
            <div className="shimmer h-3 w-32 rounded-full" data-id="element-423" data-mp="og8kgsmh7xkh" />
            <div className="shimmer h-8 w-8 rounded-lg" data-id="element-424" data-mp="ohjkqigpqn6u" />
          </div>)}
      </div>

      <div className="space-y-3 md:hidden" data-id="element-425" data-mp="jnyy1mkklfmy">
        {Array.from({
        length: 4
      }).map((_, index) => <div key={index} className="rounded-2xl border border-[var(--glass-hairline)] p-4" data-id="element-426" data-mp="ycv3rcz5mgke" data-mpi={index}>
            <div className="flex items-center gap-3" data-id="element-427" data-mp="tethkj6fm14p">
              <div className="shimmer h-11 w-11 rounded-xl" data-id="element-428" data-mp="17fmfldvxzeck" />
              <div className="flex-1 space-y-2" data-id="element-429" data-mp="17d07nd552wtt">
                <div className="shimmer h-3 w-2/3 rounded-full" data-id="element-430" data-mp="13d9c6w4o3siy" />
                <div className="shimmer h-2.5 w-1/3 rounded-full" data-id="element-431" data-mp="396hewfpcxvo1" />
              </div>
            </div>
            <div className="mt-4 space-y-2" data-id="element-432" data-mp="354vw6dq56n5x">
              <div className="shimmer h-2.5 w-full rounded-full" data-id="element-433" data-mp="35677qzptwz7l" />
              <div className="shimmer h-2.5 w-4/5 rounded-full" data-id="element-434" data-mp="184rlow7cknng" />
            </div>
          </div>)}
      </div>
    </div>;
}